<template>
  <div class="questionDetailBox">
    <h5>{{ question.title }}</h5>
    <p>{{ question.content }}</p>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "问题详情",
    };
  },
  name: "questionDetail",
  data() {
    return {
      question: "",
    };
  },
  mounted() {
    this.question = this.$store.state.state.question
      ? this.$store.state.state.question
      : "";
  },
};
</script>

<style lang="scss" scoped>
.questionDetailBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  padding: 16px;
  h5 {
    font-size: 18px;
    font-weight: bold;
    line-height: 25px;
    color: #35363c;
    padding-bottom: 16px;
  }
  p {
    font-size: 14px;
    line-height: 24px;
    color: #35363c;
    margin-top: 16px;
  }
}
</style>